import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { useCallback, useState } from 'react';
import { useRetryableObservable } from 'react-use-observable';
import ChargebackAlert from 'v2/components/Shared/ChargebackAlert';
import chargebackService from 'v2/services/chargeback';

import Breadcrumbs from '../Breadcrumbs';
import ChargebackDetails from './Details';
import Filter from './Filter';
import List from './List';
import Totalizers from './Totalizers';

const useStyle = makeStyles((theme) => ({
  root: {
    flex: 1,
    width: '100%',
  },
  title: {
    flex: '1',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#192542',
    ['& h1']: {
      fontSize: '2rem',
      lineHeight: 1,
      fontWeight: 400,
      margin: '1rem 0',
    },
    ['& p']: {
      fontSize: '1rem',
      lineHeight: '1.3125rem',
      color: '#818b9d',
    },
  },
  reports: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
}));

const Chargeback = () => {
  const classes = useStyle({});

  const [, , , retryLoadChargeback] = useRetryableObservable(() => chargebackService.loadChargebacks(), []);

  const [visible, setVisible] = useState(false);
  const [invoiceId, setInvoiceId] = useState(undefined);

  const setModalVisible = useCallback((visible: boolean, invoiceId: number) => {
    setVisible(visible);
    setInvoiceId(invoiceId);
  }, []);

  const breadcrumbsLink = [
    {
      url: '/producer/reports/sales',
      name: 'Relatórios',
    },
  ];

  return (
    <>
      <ChargebackAlert />
      <Breadcrumbs navList={breadcrumbsLink} currentPage='Chargebacks' />
      <Grid id='chargeback' container justify='space-between' alignItems='flex-start'>
        <div className={classes.title}>
          <h1>Chargebacks</h1>
          <p>Gerencie os chargebacks solicitados pelos clientes.</p>
        </div>
        <div className={classes.reports} />
      </Grid>
      <div className='m32' />
      <Filter />
      <Totalizers />
      <List setModalVisible={setModalVisible} />
      {visible && (
        <ChargebackDetails retryLoadChargeback={retryLoadChargeback} visible={visible} invoiceId={invoiceId} setModalVisible={setModalVisible} />
      )}
    </>
  );
};

export default Chargeback;
